import React from 'react';
import useForgotPasswordReset from './useForgotPasswordReset';
import ForgotPasswordContainer from './ForgotPassword.container';
import ForgotPasswordResetContext from './ForgotPasswordReset.context';
import ForgotPasswordResetSuccess from './ForgotPasswordReset.success';
import ForgotPasswordResetNoToken from './ForgotPasswordReset.notoken';

const ForgotPasswordResetPage: React.FC = () => {
  const { onSubmit, form, loading, error, success, token, passwordRequirements } =
    useForgotPasswordReset();

  return (
    <ForgotPasswordContainer>
      {!token ? (
        <ForgotPasswordResetNoToken />
      ) : success ? (
        <ForgotPasswordResetSuccess />
      ) : (
        <ForgotPasswordResetContext
          onSubmit={onSubmit}
          form={form}
          loading={loading}
          error={error}
          passwordRequirements={passwordRequirements}
        />
      )}
    </ForgotPasswordContainer>
  );
};

export default ForgotPasswordResetPage;
